(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trust-icons"] && !Shopify.designMode) return;
  try {
    
(function () {
  var PADDING = 10;
  var tooltip = document.getElementById('trust-tooltip');
  var currentItem = null;

  if (!tooltip) return;

  // Move tooltip to <body> so it's never clipped by any parent overflow
  document.body.appendChild(tooltip);

  function show(item) {
    var content = item.getAttribute('data-tooltip');
    tooltip.textContent = content || '';

    var itemRect = item.getBoundingClientRect();
    var vpW = window.innerWidth;
    var vpH = window.innerHeight;

    // Make visible off-screen first to measure
    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
    tooltip.style.display = 'block';
    tooltip.classList.remove('is-visible', 'arrow-up', 'arrow-down');

    var tw = tooltip.offsetWidth;
    var th = tooltip.offsetHeight;

    // Centered horizontally on item
    var left = itemRect.left + itemRect.width / 2 - tw / 2;
    // Clamp to viewport
    left = Math.max(PADDING, Math.min(left, vpW - tw - PADDING));

    // Try above first
    var top = itemRect.top - th - 10;
    var arrowClass = 'arrow-down';

    if (top < PADDING) {
      // Not enough room above — go below
      top = itemRect.bottom + 10;
      arrowClass = 'arrow-up';
    }

    // Arrow points to center of item
    var arrowLeft = (itemRect.left + itemRect.width / 2) - left;
    // Clamp arrow so it stays inside tooltip with some padding
    arrowLeft = Math.max(12, Math.min(arrowLeft, tw - 12));

    tooltip.style.left = left + 'px';
    tooltip.style.top  = top  + 'px';
    tooltip.style.setProperty('--arrow-left', arrowLeft + 'px');
    tooltip.style.removeProperty('visibility');
    tooltip.style.removeProperty('opacity');
    tooltip.classList.add('is-visible', arrowClass);
  }

  function hide() {
    tooltip.classList.remove('is-visible', 'arrow-up', 'arrow-down');
    if (currentItem) {
      currentItem.setAttribute('aria-expanded', 'false');
      currentItem = null;
    }
  }

  function toggle(item, e) {
    e.preventDefault();
    e.stopPropagation();

    if (currentItem === item) {
      hide();
    } else {
      currentItem = item;
      item.setAttribute('aria-expanded', 'true');
      show(item);
    }
  }

  document.querySelectorAll('.trust_icon_item').forEach(function (item) {
    item.addEventListener('click', function (e) { toggle(item, e); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') toggle(item, e);
      if (e.key === 'Escape') { hide(); item.focus(); }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.trust_icon_item')) hide();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });

  // Reposition on scroll or resize while open
  window.addEventListener('scroll', function () { if (currentItem) show(currentItem); }, true);
  window.addEventListener('resize', function () { if (currentItem) show(currentItem); });
})();

  } catch(e) { console.error(e); }
})();
})();
